define('app/views/vendor_rating_view',['app/setup'], function(takhfifan) {

  takhfifan.VendorRatingView = Backbone.View.extend({

    initialize: function() {
      this.setFill();
    },

    setFill: function() {
      var $starsFill = this.$('.tkh-stars-fill');
      var rating = parseFloat($starsFill.data('rating'));
      $starsFill.width((rating * 20 - 2)+"%");
    }
  });

});

